import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize() {
    this.element.classList.add('initialized')
  }

  addBackdrop() {
    const body = document.querySelector('body')
    const backdrop = document.createElement('div')
    backdrop.classList.add('modal--backdrop')
    body.appendChild(backdrop)
    body.classList.add('backdrop--active')
  }

  removeBackdrop() {
    const body = document.querySelector('body')
    body.classList.remove('backdrop--active')
    const backdrop = document.querySelector('.modal--backdrop')
    backdrop.remove()
  }

  open({ target }) {
    const modalId = target.closest('[data-modal]').getAttribute('data-modal')
    const modal = document.querySelector(modalId)
    if (modal) {
      this.addBackdrop()
      modal.classList.add('modal--active')
      modal.focus()
      document.addEventListener('keydown', ({ key }) => {
        if (key === 'Escape' || key === 'Esc') {
          this.close()
        }
      })
    }
  }

  close() {
    const activeModal = document.querySelector('.modal--active')
    activeModal.classList.remove('modal--active')
    this.removeBackdrop()
  }
}
